import { NgModule } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTableModule } from '@angular/material/table';
import { CdkTableModule } from '@angular/cdk/table';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

/**
 * @deprecated Please don't use this module.
 * You usually don't use all the material modules on the page.
 * So please import only necessary material modules to the module where you use it to prevent performance issues.
 */
@NgModule({
    imports: [
        MatInputModule,
        MatButtonModule,
        MatSelectModule,
        MatSidenavModule,
        MatListModule,
        MatIconModule,
        MatToolbarModule,
        MatCardModule,
        MatExpansionModule,
        CdkTableModule,
        MatTableModule,
        MatDialogModule,
        MatCheckboxModule,
        MatRadioModule,
        MatGridListModule,
        MatSnackBarModule,
        MatTabsModule,
    ],
    exports: [
        MatInputModule,
        MatButtonModule,
        MatSelectModule,
        MatSidenavModule,
        MatListModule,
        MatIconModule,
        MatToolbarModule,
        MatCardModule,
        MatExpansionModule,
        CdkTableModule,
        MatTableModule,
        MatDialogModule,
        MatCheckboxModule,
        MatRadioModule,
        MatGridListModule,
        MatSnackBarModule,
        MatTabsModule,
        MatProgressSpinnerModule,
    ],
})
export class MaterialModule {}
